import { Select as AntSelect } from 'antd';

import { FormElementWrapperNorlys, InputWrapper } from '~src/components/FormElementWrapper';

import { SelectProps } from './types';

const { Option } = AntSelect;

export const SelectNorlys = ({
  label: headerLabel,
  options = [],
  attention,
  style,
  size,
  hasEmptyOption,
  ...rest
}: SelectProps) => {
  const selectOptions = hasEmptyOption ? [...options, { label: 'Ingen', value: 'none' }] : options;

  return (
    <FormElementWrapperNorlys {...{ attention, style, size, label: headerLabel }}>
      <AntSelect {...{ style: { width: '100%' }, ...rest }}>
        {selectOptions.map(({ value, label }) => (
          <Option key={value} value={value}>
            {label}
          </Option>
        ))}
      </AntSelect>
    </FormElementWrapperNorlys>
  );
};

export const Select = ({
  label: headerLabel,
  options = [],
  attention,
  style,
  size,
  hasEmptyOption,
  ...rest
}: SelectProps) => {
  const selectOptions = hasEmptyOption ? [...options, { label: 'Ingen', value: 'none' }] : options;

  return (
    <InputWrapper {...{ attention, style, size, label: headerLabel }}>
      <AntSelect {...{ style: { width: '100%' }, ...rest }}>
        {selectOptions.map(({ value, label }) => (
          <Option key={value} value={value}>
            {label}
          </Option>
        ))}
      </AntSelect>
    </InputWrapper>
  );
};
